export const getPostalCodePlaceholder = (companyLocale: string): string => {
  switch (companyLocale) {
    case 'en_GB':
      return 'SW1E 5JL';
    case 'en_CA':
      return 'L4W 5G1';
    case 'en_US':
      return '12345';
    default:
      return '12345';
  }
};
